import PaymentData from './PaymentData';
export default PaymentData;
